import { hasPermissionSelector } from "app/selectors/permission";
import { useStoreState } from "app/store";
import { useMemo } from "react";
import { useThreadPermission } from "./useThreadPermission";

export default function useThreadMenuPermissions(thread: Moim.Forum.IThread) {
  const { isAnonymous, isMine, editPermission, visibleReportButton } =
    useStoreState(state => {
      const channel = state.entities.channels[
        thread?.root_id!
      ] as Moim.Channel.IForumSimpleChannel;
      const mine = Boolean(thread?.anonymous_data?.isMine);

      return {
        isAnonymous: Boolean(
          channel?.anonymous_config?.post ||
            channel?.anonymous_config?.reaction,
        ),
        editPermission: hasPermissionSelector(
          state,
          thread.id,
          "MANAGE_POST",
          thread.author,
        ),
        isMine: mine,
        visibleReportButton: state.app.currentUserId !== thread.author,
      };
    });

  const { hasPermission: deletePermission } = useThreadPermission({
    type: "DELETE_POST",
    thread,
  });
  const { hasPermission: hasDuplicatePostPermission } = useThreadPermission({
    type: "DUPLICATE_POST",
    thread,
  });

  const { hasPermission: visibleMovePostButton } = useThreadPermission({
    type: "MOVE_POST",
    thread,
  });

  const hasEditPermission = useMemo(
    () => editPermission || isMine,
    [editPermission, isMine],
  );
  const hasDeletePermission = useMemo(
    () => deletePermission || isMine,
    [deletePermission, isMine],
  );

  return {
    hasEditPermission,
    hasDeletePermission,
    hasDuplicatePostPermission,
    hasMovePostPermission: visibleMovePostButton && !isAnonymous,
    visibleReportButton: isAnonymous ? !isMine : visibleReportButton,
  };
}
